import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
import VueAxios from "vue-axios";
import jwt_decode from "jwt-decode";

Vue.use(Vuex)
Vue.use(VueAxios, axios);

axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'

//Vue.axios.defaults.baseURL = "https://game.testvirtual.wic.cl/";
//Vue.axios.defaults.baseURL = "http://localhost:8000/";
Vue.axios.defaults.baseURL = process.env.VUE_APP_HOST;
Vue.axios.defaults.headers.common['Authorization'] = `JWT ${localStorage.getItem('token')}`;

export default new Vuex.Store({

	state: {

		jwt: localStorage.getItem('token'),
		//user: null,
		//isAuthenticated: false,
		user: JSON.parse(localStorage.getItem('auth')),
		isAuthenticated: localStorage.getItem('isAuthenticated'),

		pruebas: [],
		prueba: {},
		escenario: [],
		ensayos: [],
		ensayo: {},
		escenarioRaw: -1,
		series: [],
		imagenes: [],
		categorias: [],
		serie: [],
		variables: [],

		roles: [
			{id: 1, name: 'Administrador'},
			{id: 2, name: 'Experto'},
			{id: 3, name: 'Normal'}
		],

		usuarios: [],
		created: {},

	},

	mutations: {

		setAuthUser(state, payload) {
			localStorage.setItem('auth', JSON.stringify(payload.authUser));
			state.user = payload.authUser;
			localStorage.setItem('isAuthenticated', payload.isAuthenticated);
			state.isAuthenticated = payload.isAuthenticated;
		},

		updateToken(state, newToken) {
			localStorage.setItem('token', newToken);
			state.jwt = newToken;
			Vue.axios.defaults.headers.common['Authorization'] = `JWT ${newToken}`;
		},

		removeToken(state) {
			localStorage.removeItem('token');
			localStorage.removeItem('auth');
			localStorage.removeItem('isAuthenticated');
			state.isAuthenticated = false;
			//localStorage.setItem('isAuthenticated', false);
			state.jwt = null;
			Vue.axios.defaults.headers.common['Authorization'] = null;
		},

		SAVE_CREATED(state, created) {
			state.created = created;
		},
		SAVE_USUARIOS(state, usuarios) {
			state.usuarios = usuarios;
		},
		SAVE_PRUEBAS(state, pruebas) {
			state.pruebas = pruebas;
		},
		SAVE_PRUEBA(state, prueba) {
			state.prueba = prueba;
			console.log('SAVE PRUEBA')
			console.log(prueba)
		},
		SAVE_ESCENARIO(state, escenario) {
			console.log(escenario);
			var aux = escenario[0];
			var mod = [
				{"name": "Radio de la piscina", "value": aux['radioPiscina'], "format": "m", "alias": "radioPiscina"},
				{"name": "Altura de la piscina", "value": aux['alturaPiscina'], "format": "m", "alias": "alturaPiscina"},
				{"name": "Distancia piscina-pared", "value": aux['distPiscinaPared'], "format": "m", "alias": "distPiscinaPared"},
				{"name": "Altura de la pared", "value": aux['alturaPared'], "format": "m", "alias": "alturaPared"},
				{"name": "Velocidad de desplazamiento", "value": aux['velocidadDesp'], "format": "m/s", "alias": "velocidadDesp"},
				{"name": "Velocidad angular", "value": aux['velocidadAngular'], "format": "m/s", "alias": "velocidadAngular"},
				{"name": "Altura del jugador", "value": aux['alturaJugador'], "format": "m", "alias": "alturaJugador"},
				{"name": "Posición de los ojos", "value": aux['posicionOjos'], "format": "m", "alias": "posicionOjos"},
				{"name": "Mensajes: Margen Superior e Inferior", "value": aux['MsgMargenSuperiorInferior'], "format": "px", "alias": "MsgMargenSuperiorInferior"},
				{"name": "Mensajes: Margen Izquierda y Derecha", "value": aux['MsgMargenIzquierdaDerecha'], "format": "px", "alias": "MsgMargenIzquierdaDerecha"},
				{"name": "Mensajes: Tamano de fuente", "value": aux['MsgFontSize'], "format": "m", "alias": "MsgFontSize"},
				{"name": "Mensajes: Familia de fuente", "value": aux['MsgFontFamily'], "format": "m", "alias": "MsgFontFamily"},
			];
			mod = mod.map(function(el) {
				var o = Object.assign({}, el);
				o.isEditing = false;
				o.preValue = undefined;
				return o;
			})
			state.escenario = mod;
		},
		SAVE_RAW_ESCENARIO(state, escenario) {
			state.escenarioRaw = escenario[0];
		},
		SAVE_ENSAYOS(state, ensayos) {
			state.ensayos = ensayos;
		},
		SAVE_VARIABLES(state, variables) {
			state.variables = variables;
		},
		SAVE_SERIES(state, series) {
			var i = 1; 
			state.series = series.map(function(el) {
				var o = Object.assign({}, el);
				o.order = i;
				i++;
				return o;
			})
		},
		SAVE_SERIE(state, serie) {
			state.serie = serie;
		},
		SAVE_ENSAYO(state, ensayo) {
			const aux = ensayo;
			var mod = [
				{"name": "Nombre de ensayo", "value": aux['nombreEnsayo'], "format": "texto", "alias": "nombreEnsayo"},
				{"name": "Ensayo de inicio", "value": aux['ensayoInicio'], "format": "-", "alias": "ensayoInicio"},
				{"name": "Nombre Etapa Ensayo Inicio", "value": aux['ensayoInicioNombreEtapa'], "format": "texto", "alias": "ensayoInicioNombreEtapa"},
				{"name": "Mensaje Ensayo de inicio", "value": aux['ensayoInicioMensaje'], "format": "texto", "alias": "ensayoInicioMensaje"},
				{"name": "Duración", "value": aux['tiempoDuracion'], "format": "seg", "alias": "tiempoDuracion"},
				{"name": "Radio de la plataforma", "value": aux['radioPlataforma'], "format": "m", "alias": "radioPlataforma"},
				{"name": "Posición de plataforma aleatoria", "value": aux['posicionPlataformaAleatoria'], "format": "-", "alias": "posicionPlataformaAleatoria"},
				{"name": "Posición eje X de la plataforma", "value": aux['posicionPlataformaX'], "format": "m", "alias": "posicionPlataformaX"},
				{"name": "Posición eje Y de la plataforma", "value": aux['posicionPlataformaY'], "format": "m", "alias": "posicionPlataformaY"},
				{"name": "Visibilidad plataforma", "value": aux['visibilidadPlataforma'], "format": "-", "alias": "visibilidadPlataforma"},
				{"name": "Tiempo de aparición de plataforma", "value": aux['visibilidadPlataformaTiempo'], "format": "seg", "alias": "visibilidadPlataformaTiempo"},
				{"name": "Posición del jugador aleatoria", "value": aux['posicionJugadorAleatoria'], "format": "-", "alias": "posicionJugadorAleatoria"},
				{"name": "Posición eje X del jugador", "value": aux['posicionJugadorX'], "format": "m", "alias": "posicionJugadorX"},
				{"name": "Posición eje Y del jugador", "value": aux['posicionJugadorY'], "format": "m", "alias": "posicionJugadorY"},
				{"name": "Orientacion del jugador aleatoria", "value": aux['orientacionJugadorAleatoria'], "format": "-", "alias": "orientacionJugadorAleatoria"},
				{"name": "Orientación angular del jugador", "value": aux['orientacionJugadorAngulo'], "format": "m", "alias": "orientacionJugadorAngulo"},
				{"name": "Orientación eje Z del jugador", "value": aux['orientacionJugadorEjeZ'], "format": "m", "alias": "orientacionJugadorEjeZ"},
				{"name": "Textura de piscina", "value": aux['texturaPiscina'], "format": "texto", "alias": "texturaPiscina"},
				{"name": "¿Tiene Sala de Espera?", "value": aux['tieneSalaEspera'], "format": "-", "alias": "tieneSalaEspera"},
				{"name": "Tiempo Sala de Espera", "value": aux['tiempoSalaEspera'], "format": "seg", "alias": "tiempoSalaEspera"},
			]
			mod = mod.map(function(el) {
				var o = Object.assign({}, el);
				o.isEditing = false;
				o.preValue = undefined;
				return o;
			})
			aux.detail = mod
			var i = 1; 
			aux.clave_set = aux.clave_set.map(function(el) {
				var o = Object.assign({}, el);
				o.isEditing = false;
				o.preNombre = undefined;
				o.prePared = undefined;
				o.prePosX = undefined;
				o.prePosY = undefined;
				o.preHeight = undefined;
				o.preWidth = undefined;
				o.order = i;
				i++;
				return o;
			})
			aux.mensaje_set = aux.mensaje_set.map(function(el) {
				var o = Object.assign({}, el);
				o.isEditing = false;
				o.preText = undefined;
				o.preShowtime = undefined;
				o.preTime = undefined;
				o.preWaitingroom = undefined;
				o.preSoundactivate = undefined;
				return o;
			})
			state.ensayo = aux;
		},
		SAVE_IMAGENES(state, imagenes) {
			state.imagenes = imagenes;
		},
		SAVE_CATEGORIAS(state, categorias) {
			let aux = categorias.map(function(el) {
				var o = Object.assign({}, el);
				if (o.children.length == 0) {
					o.disabled = true;
				}
				return o;
			})
			state.categorias = aux;
		},
	},

	actions: {
		refreshToken({commit}) {
			const payload = {
				token: this.state.jwt
			}
			Vue.axios.post('auth/refresh_token/', payload).then((response) => {
				commit('updateToken', response.data.token);
			})
			.catch((error) => {
				commit('removeToken');
				throw new Error(`API ${error}`);
			})
		},

		inspectToken({dispatch, commit}){

			const token = this.state.jwt;

			if (token) {

				const decoded = jwt_decode(token);
				const exp = decoded.exp
				const orig_iat = decoded.orig_iat

				const max = 628200;
				const min = 60;
				const time = 60 * 60;
				const diff = exp - Date.now() / 1000;
				const life = Date.now() / 1000 - orig_iat;

				if (diff > min && diff < time && life < max) {
					dispatch('refreshToken');
				} 
				else if (diff < min || life > max) {
					commit('removeToken');
				} 

			}
		},

		createUsuario({dispatch, commit}, payload) {
			Vue.axios.post('usuarios/', payload).then(result => {
				console.log(result);
				commit('SAVE_CREATED', result.data);
				dispatch('loadUsuarios');
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		editUsuario({dispatch}, payload) {
			Vue.axios.put('usuarios/' + payload.id + '/', payload).then(result => {
				console.log(result);
				dispatch('loadUsuarios');
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		deleteUsuario({dispatch}, payload) {
			Vue.axios.delete('usuarios/' + payload + '/').then(result => {
				console.log(result);
				dispatch('loadUsuarios');
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		loadUsuarios({commit}) {
			Vue.axios.get('usuarios/').then(result => {
				commit('SAVE_USUARIOS', result.data);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		loadPruebas({commit}) {
			Vue.axios.get('pruebas/').then(result => {
				commit('SAVE_PRUEBAS', result.data);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		loadPrueba({commit}, payload) {
			console.log('LOAD PRUEBA')
			Vue.axios.get('pruebas/' + payload.id + '/').then(result => {
				commit('SAVE_PRUEBA', result.data);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		loadEscenario({commit}, payload) {
			Vue.axios.get('escenario/' + payload.id + '/').then(result => {
				commit('SAVE_ESCENARIO', result.data);
				commit('SAVE_RAW_ESCENARIO', result.data);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		loadEnsayos({commit}, payload) {
			Vue.axios.get('ensayos/' + payload.id + '/').then(result => {
				commit('SAVE_ENSAYOS', result.data);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		loadEnsayoDetail({commit}, payload) {
			Vue.axios.get('ensayo/' + payload.id + '/').then(result => {
				commit('SAVE_ENSAYO', result.data);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		savePrueba({dispatch}, payload) {
			Vue.axios.post('prueba/', payload).then(result => {
				console.log(result);
				dispatch('loadPruebas');
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		savePruebaConfig({dispatch}, payload) {
			console.log('SAVE PRUEBA CONFIG')
			Vue.axios.put('pruebas/', payload.item).then(result => {
				console.log(result);
				dispatch('loadPruebas');
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		deletePrueba({dispatch}, payload) {
			Vue.axios.delete('pruebas/' + payload.id + '/').then(result => {
				console.log(result);
				dispatch('loadPruebas');
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		editEscenario({commit}, payload) {
			Vue.axios.put('escenarios/' + payload.id + '/', payload.item).then(result => {
				console.log(result);
				commit('SAVE_ESCENARIO', [result.data]);
				commit('SAVE_RAW_ESCENARIO', [result.data]);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		createEnsayo({dispatch}, payload) {
			Vue.axios.post('ensayos/' + payload.id + '/', payload).then(result => {
				console.log(result);
				dispatch('loadEnsayos', payload);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		deleteEnsayo({dispatch}, payload) {
			Vue.axios.delete('ensayo/' + payload.item.id + '/').then(result => {
				console.log(result);
				dispatch('loadEnsayos', payload);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		createClave({dispatch}, payload) {
			Vue.axios.post('claves/' + payload.id + '/', payload.item).then(result => {
				console.log(result);
				dispatch('loadEnsayoDetail', payload);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		deleteClave({dispatch}, payload) {
			Vue.axios.delete('clave/' + payload.item.id + '/').then(result => {
				console.log(result);
				dispatch('loadEnsayoDetail', payload);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		editClave({dispatch}, payload) {
			Vue.axios.put('claves/' + payload.item.id + '/', payload.item).then(result => {
				console.log(result);
				dispatch('loadEnsayoDetail', payload);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		createMensaje({dispatch}, payload) {
			Vue.axios.post('mensajes/' + payload.id + '/', payload.item).then(result => {
				console.log(result);
				dispatch('loadEnsayoDetail', payload);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		deleteMensaje({dispatch}, payload) {
			Vue.axios.delete('mensaje/' + payload.item.id + '/').then(result => {
				console.log(result);
				dispatch('loadEnsayoDetail', payload);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		editMensaje({dispatch}, payload) {
			Vue.axios.put('mensaje/' + payload.item.id + '/', payload.item).then(result => {
				console.log(result);
				dispatch('loadEnsayoDetail', payload);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		editEnsayo({dispatch}, payload) {
			Vue.axios.put('ensayo/' + payload.id + '/', payload.item).then(result => {
				console.log(result);
				dispatch('loadEnsayoDetail', payload);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		loadSeries({commit}, payload) {
			Vue.axios.get('series/' + payload.id + '/').then(result => {
				commit('SAVE_SERIES', result.data);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		loadSerieDetail({commit}, payload) {
			Vue.axios.get('serie/' + payload.id + '/').then(result => {
				commit('SAVE_SERIE', result.data['data']);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		loadSerieVariables({commit}, payload) {
			Vue.axios.get('variables/' + payload.id + '/').then(result => {
				commit('SAVE_VARIABLES', result.data);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		deleteSerie({dispatch}, payload) {
			Vue.axios.delete('serie/' + payload.item.id + '/').then(result => {
				console.log(result);
				dispatch('loadSeries', payload);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		loadImagenes({commit}) {
			Vue.axios.get('imagenes/').then(result => {
				commit('SAVE_IMAGENES', result.data);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		loadCategorias({commit}) {
			Vue.axios.get('categorias/').then(result => {
				commit('SAVE_CATEGORIAS', result.data);
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		saveImagen({dispatch}, payload) {
			Vue.axios.post(
				'imagen/', 
				payload,
				{
					headers: {
						"Content-Type": "multipart/form-data"
					},
				}
			)
			.then(result => {
				console.log(result);
				dispatch('loadCategorias');
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		deleteImagen({dispatch}, payload) {
			Vue.axios.delete('imagenes/' + payload.id + '/').then(result => {
				console.log(result);
				dispatch('loadCategorias');
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		deleteCategoria({dispatch}, payload) {
			Vue.axios.delete('categorias/' + payload.id + '/').then(result => {
				console.log(result);
				dispatch('loadCategorias');
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
		saveCategoria({dispatch}, payload) {
			Vue.axios.post('categoria/', payload).then(result => {
				console.log(result);
				dispatch('loadCategorias');
			}).catch(error => {
				throw new Error(`API ${error}`);
			});
		},
	},
})